import { render, staticRenderFns } from "./ThreatRelatedEvidenceTable.vue?vue&type=template&id=164713fc&"
import script from "./ThreatRelatedEvidenceTable.vue?vue&type=script&lang=js&"
export * from "./ThreatRelatedEvidenceTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports